import type { Database } from '@/entities/database';
import request from '@/shared/api/request';

export const resizeDatabase = (uuid: string, size: string): Promise<{ database: Database }> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'resize', size },
  });
